<i18n src="../../lib/i18n/product/locales.json"></i18n>
<template>
    <Row class="iapp">
        <!--导航栏-->
        <navbar :transparent="isTransparent" activeTo="Home"></navbar>
        <!-- iapp 下载-->
        <section class="banner">
            <div class="iapp-bg">
                <div class="iapp-page max_width">
                    <div class="iapp_title">
                        <div class="iapp_title_img">
                            <img src="../../assets/profile/iapp_icon.png" width="50%">
                        </div>
                    </div>
                    <div class="iapp_home">
                        <i-col :lg="10" :md="10" :sm="24" :xl="24" class="iapp_home_right">
                            <img src="../../assets/iapp/app_home.png" v-if="type==='a' ">
                            <img src="../../assets/iapp/app_home_fancn.png" v-else-if="type==='b' ">
                            <img src="../../assets/iapp/app_home_fancn.png" v-else-if="type==='c' ">
                        </i-col>
                        <i-col :lg="14" :md="14" :sm="24" :xl="24" class="iapp_home_left">
                            <div class="iapp_home_content">{{$t('iapp_title')}}</div>
                            <div class="iapp_home_content_tips">{{$t('iapp_sm_title')}}</div>
                            <div class="iapp_download_container ">
                                <div class="iapp_download_item">
                                    <img class="iapp_qrcode" src="../../assets/xiaochengxu.png">
                                    <p>{{$t('mini_program')}}</p>
                                </div>
                                <div class="iapp_download_item">
                                    <img class="iapp_qrcode" src="../../assets/iapp.png">
                                    <p>{{$t('user_center_iapp_qrcode')}}</p>
                                </div>
                                <div class="iapp_download_item" id="mobile_hide">
                                    <a href="https://itunes.apple.com/cn/app/iapp-best-travel-companion/id1210741206?mt=8">
                                        <img class="ios_download" src="../../assets/iapp/iOS@2x.png">
                                    </a>
                                    <a href="http://ifree.ly/android">
                                        <img class="android_download" src="../../assets/iapp/Android@2x.png">
                                    </a>
                                </div>
                            </div>
                            <p class="home_title_img">iAPP</p>
                        </i-col>
                    </div>
                </div>
            </div>
        </section>
        <div style="clear: both"></div>
        <section class="iapp_content">
            <div class="iapp_tab_main max_width">
                <i-col :lg="12" :md="12" :sm="12" :xl="12">
                    <div class="iapp_tab " >{{$t('iapp_content')}}</div>
                    <div class="iapp_tab_group">
                        <div class="iapp_tab_item" style="cursor: pointer" v-for="(item,index) in tabs" :key="index" :class="{active:index == num}"  @click="tab(index)">
                            {{item.title}}
                        </div>
                    </div>
                    <div class="iapp_tab_content">
                        <div class="iapp_tab_creen_content"  v-for='(itemCon,index) in tabContents' v-show="index == num" :key="index">
                            <div class="part1">
                                <p class="part_title">{{itemCon.title1}}</p>
                                <p class="part_content">{{itemCon.content1}}</p>
                            </div>
                            <div class="part2">
                                <p class="part_title">{{itemCon.title2}}</p>
                                <p class="part_content">{{itemCon.content2}}</p>
                            </div>
                            <div class="part2" style="z-index: 111;position: relative" v-show="index == 1">
                                <div class="part_title" style="text-align: left;">
                                    <router-link :to="{name:'iVoice'}" class="text-primary">
                                        <a style="font-size:16px;font-weight: 500;color: #0084ff;">{{$t('Services_mainpage_remain_to_be_solved')}} <Icon type="arrow-right-c"></Icon></a>
                                    </router-link>
                                </div>
                            </div>

                        </div>
                    </div>
                </i-col>
                <i-col  :lg="12" :md="12" :sm="12" :xl="12">
                    <div class="iapp_img">
                        <div v-if="show === 'a'">
                            <img src="../../assets/iapp/app_store.png" width="100%"  v-if="type1==='a' ">
                            <img src="../../assets/iapp/app_store_fancn.png" width="100%" v-else-if="type1 ==='b' ">
                            <img src="../../assets/iapp/app_store_cn.png" width="100%" v-else-if="type1 ==='c' ">
                        </div>
                        <div v-else-if="show === 'b'">
                            <img src="../../assets/iapp/app_iVoice.png" width="100%" >
                        </div>
                        <div v-else-if="show === 'c'">
                            <img src="../../assets/iapp/app_im.png" width="100%"  v-if="type2==='a' ">
                            <img src="../../assets/iapp/app_im_fancn.png" width="100%" v-else-if="type2==='b' ">
                            <img src="../../assets/iapp/app_im_cn.png" width="100%" v-else-if="type2==='c' ">
                        </div>
                    </div>
                </i-col>
                <i-col :span="24">
                    <div class="footer_img" v-if="show === 'a'">
                        <p class="footer_p">STORE</p>
                    </div>
                    <div class="footer_img" v-else-if="show === 'b'">
                        <p class="footer_p">IVOICE</p>
                    </div>
                    <div class="footer_img" v-else-if="show === 'c'">
                        <p class="footer_p">MESSAGE</p>
                    </div>
                </i-col>
            </div>

        </section>
    </Row>
</template>

<script>
    import navbar from '../Common/Navbar.vue'

    export default {
        data () {
            return {
                isTransparent: false,
                num: 0,
                lang: '',
                type: 'b',
                type1:'b',
                type2: 'b',
                show: 'a',
                tabs: [
                    {
                        title: 'Store'
                    },
                    {
                        title: 'iVoice'
                    },
                    {
                        title: 'Message'
                    }
                ],
                tabContents: [
                    {
                        title1 : this.$t('iapp_tab_one_title'),
                        content1: this.$t('iapp_tab_one_content'),
                        title2: this.$t('iapp_tab_one_title1'),
                        content2: this.$t('iapp_tab_one_content1')
                    },
                    {
                        title1 : this.$t('iapp_tab_two_title'),
                        content1: this.$t('iapp_tab_two_content'),
                        title2: this.$t('iapp_tab_two_title1'),
                        content2: this.$t('iapp_tab_two_content1')
                    },
                    {
                        title1 : this.$t('iapp_tab_three_title'),
                        content1: this.$t('iapp_tab_three_content'),
                        title2: this.$t('iapp_tab_three_title1'),
                        content2: this.$t('iapp_tab_three_content1')
                    }
                ]
            }
        },
        components: {
            navbar
        },
        methods: {
            //自动轮播
            autoPlay () {
                this.num++;
                if (this.num == 3) {
                    this.num = 0
                }
                if(this.num == 0) {
                    this.show = 'a'
                }else if (this.num == 1) {
                    this.show = 'b'
                }else if (this.num == 2) {
                    this.show = 'c'
                }
            },
            //添加一个计时器
            play () {
                setInterval(this.autoPlay, 3000)
            },
            tab (index) {
                this.num = index
                this.current = index

                if(index === 0) {
                    this.show = 'a'
                }else if (index == 1) {
                    this.show = 'b'
                }else if (index == 2) {
                    this.show = 'c'
                }
            }
        },
        created () {
            // 判断语言包
            this.lang = this.$i18n.locale
            console.log(this.lang)
            if (this.lang === 'en-US') {
                this.type = 'a'
                this.type1 = 'a'
                this.type2 = 'a'
            }else if (this.lang === 'zh-HK') {
                this.type = 'b'
                this.type1 = 'b'
                this.type2 = 'b'
            }else if (this.lang === 'zh-CN') {
                this.type = 'c'
                this.type1 = 'c'
                this.type2 = 'c'
            }
            // 自动轮播
            this.play()
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../scss/_iapp.scss";
</style>



// WEBPACK FOOTER //
// iapp.vue?f72f959e